module.exports = __webpack_public_path__ + "static/assets/49a8736bf7fbb79e2469272f127e06d3.svg";